<template>
  <v-dialog
    v-model="cloudBankingInstitutionDialog"
    :value="isActive"
    @click:outside="$emit('update:isActive', false)"
    width="400px"
  >
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>{{ method === "post" ? "Add" : "Edit" }} Institution</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-bank</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :method="method"
          :fields.sync="cloudBankingInstitution"
          :action="url"
          @submitted="$emit('changed', $event)"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-select
                  name="type"
                  :items="types"
                  label="Type of institution"
                  item-text="label"
                  item-value="value"
                  @changed="filterByType"
                />
                <custom-select
                  name="country"
                  :items="countries"
                  label="Country"
                  item-text="name"
                  item-value="code"
                  @changed="filterByCountry"
                />
                <custom-select
                  name="currency"
                  :items="currencies"
                  label="Currency"
                  item-text="name"
                  @changed="filterByCurrency"
                />
                <custom-combobox
                  ref="name"
                  name="name"
                  item-value="label"
                  item-text="label"
                  :items="finstitutions"
                  label="Institution"
                  @change="getFirstMatchReference"
                  @keyup="randomReferenceFromNameSearch"
                  @paste="randomReferenceFromName"
                >
                </custom-combobox>
                <custom-input ref="reference" name="reference" label="Reference" />
              </v-col>
              <v-col cols="12">
                <custom-button block color="primary">
                  <v-icon v-if="method === 'post'">mdi-plus</v-icon>
                  <v-icon v-else>mdi-pencil</v-icon>
                  {{ method === "post" ? "Add" : "Edit" }}
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    cloudBankingInstitutionDialog: { required: true, type: Boolean },
    cloudBankingInstitution: {
      default: () => {},
      type: Object,
    },
    institution: {
      default: () => {},
      type: Object,
    },
    method: { default: "post", type: String },
    cloud_banking_institution: {
      default: () => {},
      type: Object,
    },
    institutions: {
      default: () => {},
      type: Array,
    },
  },

  data() {
    return {
      type: null,
      currency: null,
      country: null,
      cloud_banking_institutions: [],
      countries: [],
      currencies: [{ name: "XOF" }, { name: "XAF" }, { name: "EUR" }, { name: "GNF" }],
      types: [
        { value: "bank_transfer", label: "Bank" },
        { value: "mobile_money", label: "Mobile Money operator" },
        { value: "mfi", label: "Microfinance institution" },
      ],
      name: "",
      finstitutions: [...this.institutions],
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.fetchCountries();
    },
    fetchCountries() {
      return this.$http.get("/api/v1/get-countries").then((data) => (this.countries = data));
    },
    filterByType(type) {
      this.type = type;
      this.filterAvailableInstitutions();
    },
    filterByCountry(country) {
      this.country = country;
      this.filterAvailableInstitutions();
    },
    filterByCurrency(currency) {
      this.currency = currency;
      this.filterAvailableInstitutions();
    },
    filterAvailableInstitutions() {
      this.finstitutions = [...this.institutions];
      if (this.type !== null) {
        this.finstitutions = this.finstitutions.filter((institution) => {
          return this.type === institution.type;
        });
      }
      if (this.country !== null) {
        this.finstitutions = this.finstitutions.filter((institution) => {
          const found = institution.subinstitutions.find(
            (subinstitution) => subinstitution.country === this.country,
          );
          return found !== undefined;
        });
      }
      if (this.currency !== null) {
        this.finstitutions = this.finstitutions.filter((institution) => {
          const found = institution.subinstitutions.find(
            (subinstitution) => subinstitution.currency === this.currency,
          );
          return found !== undefined;
        });
      }
    },
    getFirstMatchReference(institution) {
      let fsubinstitutions = [...institution.subinstitutions];
      if (this.country !== null) {
        fsubinstitutions = fsubinstitutions.filter(
          (subinstitution) => subinstitution.country === this.country,
        );
      }
      if (this.currency !== null) {
        fsubinstitutions = fsubinstitutions.filter(
          (subinstitution) => subinstitution.currency === this.currency,
        );
      }
      if (fsubinstitutions.length && fsubinstitutions[0].reference) {
        this.$refs.reference.currentValue = fsubinstitutions[0].reference;
      } else {
        this.$refs.reference.currentValue = this.randomReference(institution.label);
      }
    },
    randomReferenceFromName(event) {
      const str = event.target.value;
      this.$refs.reference.currentValue = this.randomReference(str);
    },
    randomReferenceFromNameSearch(event) {
      const str = event.target.value;
      this.$refs.reference.currentValue = this.randomReference(str);
      this.$refs.name.currentValue = str;
    },
    randomReference(str) {
      const regexp = /[A-Z0-9]/g;
      const ar = [...str.matchAll(regexp)];
      let codes = [];
      for (let a of ar) {
        codes.push(a[0]);
      }
      let code = codes.join("");
      if (!/\d/.test(code)) {
        code += "/DP-" + this.country + this.currency;
      }
      return code;
    },
  },

  computed: {
    url() {
      if (this.cloudBankingInstitution && this.cloudBankingInstitution.id) {
        return `api/v1/${this.$route.params.id}/institutions/${this.cloudBankingInstitution.id}`;
      }
      return `api/v1/${this.$route.params.id}/institutions`;
    },
  },
};
</script>
